<template>

    <templatesite>

        <template v-slot:appheader>  <appheader></appheader>  </template>
        <template v-slot:appsidebar>  <appsidebar></appsidebar> </template>
        <template v-slot:appcontent>

            <appmenu></appmenu>

            <div class="content" style="margin-top: 0">

                <div class="main-content">


                    <div class="container">
                        <!-- Page Header -->
                        <div class="block justify-between page-header md:flex">
                            <div>
                                   </div>
                            <ol class="flex items-center whitespace-nowrap min-w-0">

                            </ol>
                        </div>

                        <div class="grid grid-cols-12 gap-6 mb-[3rem]">
                            <div class="xl:col-span-12 col-span-12">
                                <div class="box">
                                    <div class="box-header">
                                        <nav aria-label="Tabs" class="grid grid-cols-2 md:grid-cols-4 gap-2 w-full">

                                            <a class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all active"
                                               id="informationentreprise-item" data-hs-tab="#informationentreprise" aria-controls="informationentreprise">
                                                <i class="ri-building-2-line text-lg"></i>
                                                <span class="text-center leading-tight">Infos entreprise</span>
                                            </a>

                                            <a class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="account-item" data-hs-tab="#account-settings" aria-controls="account-settings">
                                                <i class="ri-shield-check-line text-lg"></i>
                                                <span class="text-center leading-tight">Autorisations système</span>
                                            </a>

                                            <a class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="email-item" data-hs-tab="#email-settings" aria-controls="email-settings">
                                                <i class="ri-pen-nib-line text-lg"></i>
                                                <span class="text-center leading-tight">Signataires éditions</span>
                                            </a>

                                            <a class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-item" data-hs-tab="#labels" aria-controls="labels">
                                                <i class="ri-upload-cloud-line text-lg"></i>
                                                <span class="text-center leading-tight">Téléch. signatures</span>
                                            </a>

                                            <a class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-notification" data-hs-tab="#gestnotification" aria-controls="gestnotification">
                                                <i class="ri-notification-3-line text-lg"></i>
                                                <span class="text-center leading-tight">Notifications</span>
                                            </a>

                                            <a class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-libelle" data-hs-tab="#gestlibelle" aria-controls="gestlibelle">
                                                <i class="ri-price-tag-3-line text-lg"></i>
                                                <span class="text-center leading-tight">Libellés</span>
                                            </a>

                                            <a @click="loadtokennormalisation" class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-tokenormalisation" data-hs-tab="#gesttokennormalisation" aria-controls="gesttokennormalisation">
                                                <i class="ri-key-2-line text-lg"></i>
                                                <span class="text-center leading-tight">Token normalisation</span>
                                            </a>

                                            <a @click="chargerServeurDevices" class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-serveurdevices" data-hs-tab="#gestserveurdevices" aria-controls="gestserveurdevices">
                                                <i class="ri-smartphone-line text-lg"></i>
                                                <span class="text-center leading-tight">Appareils serveurs</span>
                                            </a>

                                            <a @click="chargerUtilisateursConnectes" class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-usersconnectes" data-hs-tab="#gestusersconnectes" aria-controls="gestusersconnectes">
                                                <i class="ri-group-line text-lg"></i>
                                                <span class="text-center leading-tight">Utilisateurs connectés</span>
                                            </a>

                                            <a @click="chargerAuditPaniers" class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-auditpaniers" data-hs-tab="#gestauditpaniers" aria-controls="gestauditpaniers">
                                                <i class="ri-shopping-basket-2-line text-lg"></i>
                                                <span class="text-center leading-tight">Audit paniers</span>
                                            </a>

                                            <a @click="chargerShortlinks" class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-shortlinks" data-hs-tab="#gestshortlinks" aria-controls="gestshortlinks">
                                                <i class="ri-link text-lg"></i>
                                                <span class="text-center leading-tight">Liens courts</span>
                                            </a>

                                            <a class="hs-tab-active:bg-primary/10 hs-tab-active:text-primary hs-tab-active:border-primary
                                               cursor-pointer flex flex-col items-center justify-center gap-1 py-3 px-2
                                               text-defaulttextcolor text-[0.72rem] font-medium
                                               rounded-md border border-transparent hover:border-primary/30 hover:text-primary
                                               hover:bg-primary/5 transition-all"
                                               id="labels-reinitialisation" data-hs-tab="#gestreinitialisation" aria-controls="gestreinitialisation">
                                                <i class="ri-delete-bin-2-line text-lg"></i>
                                                <span class="text-center leading-tight">Réinitialisation BDD</span>
                                            </a>

                                        </nav>
                                    </div>
                                    <div class="box-body">
                                        <div class="tab-content">


                                            <div class="tab-pane " id="informationentreprise" aria-labelledby="informationentreprise-item" role="tabpanel">

                                                <div class="grid grid-cols-12 gap-4">

                                                    <div class="xl:col-span-12 col-span-12">

                                                        <div class="grid grid-cols-12 gap-4">

                                                            <div class="xl:col-span-6 col-span-12">
                                                                <label class="input input--file">
                                                                    <span class="input__text">Fichier <sup title="required">*</sup></span>
                                                                    <input type="file" id="filelogo" ref="logofile" v-on:change="logopreviewImage" class="input__field" accept="image/*" required>
                                                                    <span class="input__support">
                                                                    <span class="input__helper"></span>
                                                                  </span>
                                                                </label>
                                                            </div>

                                                            <div class="xl:col-span-6 col-span-12">

                                                                <div class="border p-2 mt-3">
                                                                    <p>Aperçu du fichier :</p>
                                                                    <template v-if="logopreview">
                                                                        <img :src="logopreview" class="img-fluid" />
                                                                        <p class="mb-0">Nom du fichier: {{ logoimage.name }}</p>
                                                                        <p class="mb-0">Taille du fichier: {{ logoimage.size/1024 }}KB</p>


                                                                        <div class="xl:col-span-12 col-span-12 mt-7">
                                                                            <div class="progress progress-xs">
                                                                                <div class="progress-bar !bg-info" :style="`width: ${logouploadPercentage}%`" role="progressbar" :aria-valuenow="logouploadPercentage" aria-valuemin="0" aria-valuemax="100"> </div>
                                                                            </div>

                                                                            <h3 ref="logostatus" id="logostatus"></h3>
                                                                            <p ref="logoloaded_n_total" id="logoloaded_n_total"></p>
                                                                        </div>



                                                                    </template>
                                                                    <template v-else>

                                                                        <img v-if="etatinformationentreprise.logo!==null" :src="$store.state.baseurlapifile+etatinformationentreprise.logo" class="img-fluid" />

                                                                    </template>
                                                                </div>



                                                            </div>


                                                        </div>


                                                    </div>

                                                            <div class="xl:col-span-6 col-span-12">
                                                                <label >IFU </label>
                                                                <input type="text" class="form-control w-full"  v-model="etatinformationentreprise.ifu">
                                                            </div>

                                                            <div class="xl:col-span-6 col-span-12">
                                                                <label >RCCM </label>
                                                                <input type="text" class="form-control w-full"  v-model="etatinformationentreprise.rccm">
                                                            </div>




                                                        <div class="xl:col-span-12 col-span-12">
                                                            <label >Raison sociale </label>
                                                            <input type="text" class="form-control w-full"  v-model="etatinformationentreprise.raisonsociale">
                                                        </div>

                                                        <div class="xl:col-span-6 col-span-12">
                                                            <label >Adresse </label>
                                                            <input type="text" class="form-control w-full"  v-model="etatinformationentreprise.adresse">
                                                        </div>

                                                        <div class="xl:col-span-6 col-span-12">
                                                            <label >Téléphone </label>
                                                            <input type="text" class="form-control w-full"  v-model="etatinformationentreprise.telephonne">
                                                        </div>





                                                    <div class="xl:col-span-12 col-span-12">
                                                        <div class="ltr:float-right rtl:float-left">

                                                            <button @click="submitFileinformationentreprise" type="button" class="ti-btn bg-primary text-white m-1">
                                                                Enregistrer les modifications
                                                            </button>
                                                        </div>
                                                    </div>




                                                </div>



                                            </div>

                                            <div class="tab-pane hidden" id="account-settings" aria-labelledby="account-item"
                                                 role="tabpanel">

                                                 <div class="">


                                                 <div class="grid grid-cols-12 gap-4">
                                                    <div class="xl:col-span-12 col-span-12">
                                                        <div class="box  shadow-none mb-0 border">
                                                            <div class="box-body">

                                                                <div class="block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Autoriser la normalisation des factures ? :</span>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">
                                                                             <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                <input id="authorizenormalisation" v-model="autorisationsystem.authorizenormalisation" type="checkbox" checked>
                                                                                <label for="authorizenormalisation" class="label-primary mb-1"></label>
                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Autoriser l'utilisation des signatures électroniques? :</span>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">

                                                                            <div class="xl:col-span-12 col-span-12">
                                                                                <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                    <input id="authorizesignatureelectronique" v-model="autorisationsystem.authorizesignatureelectronique" type="checkbox" checked>
                                                                                    <label for="authorizesignatureelectronique" class="label-primary mb-1"></label>
                                                                                </div>
                                                                           </div>

                                                                    </div>

                                                                </div>
                                                               </div>

                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Autoriser le payement partiel des factures de vente ? :</span>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">

                                                                            <div class="xl:col-span-12 col-span-12">
                                                                                <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                    <input id="authorizefacturactionpartiel" v-model="autorisationsystem.authorizefacturactionpartiel" type="checkbox" checked>
                                                                                    <label for="authorizefacturactionpartiel" class="label-primary mb-1"></label>
                                                                                </div>
                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Accepter que le montant reçu soit égale à 0 ? :</span>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">

                                                                            <div class="xl:col-span-12 col-span-12">
                                                                                <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                    <input id="authorizeprix0" v-model="autorisationsystem.authorizeprix0" type="checkbox" checked>
                                                                                    <label for="authorizeprix0" class="label-primary mb-1"></label>
                                                                                </div>
                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Autoriser la validation des documents(Gestion commerciale) ? :</span>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">

                                                                            <div class="xl:col-span-12 col-span-12">
                                                                                <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                    <input id="authorizevalidationdoc" v-model="autorisationsystem.authorizevalidationdoc" type="checkbox" checked>
                                                                                    <label for="authorizevalidationdoc" class="label-primary mb-1"></label>
                                                                                </div>
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Autoriser la gestion des points de vente? :</span>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">

                                                                            <div class="xl:col-span-12 col-span-12">
                                                                                <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                    <input id="authorizepointdevente" v-model="autorisationsystem.authorizepointdevente" type="checkbox" checked>
                                                                                    <label for="authorizepointdevente" class="label-primary mb-1"></label>
                                                                                </div>
                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Utiliser la procédure de validation des documents de stock :</span>
                                                                            <p class="text-[0.75rem] text-[#8c9097] mb-0"> Si oui (tous les documents de stock crée doivent subir une validation avant d'impacter le stock)</p>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">

                                                                            <div class="xl:col-span-12 col-span-12">
                                                                                <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                    <input id="authorizelaproceduredevalidationdocstock" v-model="autorisationsystem.authorizelaproceduredevalidationdocstock" type="checkbox" checked>
                                                                                    <label for="authorizelaproceduredevalidationdocstock" class="label-primary mb-1"></label>
                                                                                </div>
                                                                            </div>




                                                                        </div>

                                                                    </div>

                                                                </div>


                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-8 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Validation des documents
                                                                                <br>
                                                                                (<span style="color: red;font-weight: bold;">NB : En choisissant cette option, si le document n'est pas validé après la demande,
                                                                                  vous ne pourrez pas lancer la transformation, l'impression ou la modification du document.</span>)
                                                                                :
                                                                              <span class="help-block" style="margin-top: 5px;font-size: 10px">
                                                                                        Documents de vente :
                                                                                    <ul>
                                                                                        <li>Bon de commande</li>
                                                                                        <li>Bon de préparation de livraison</li>
                                                                                        <li>Bon de livraison</li>
                                                                                        <li>Facture</li>
                                                                                        <li>Retours sur ventes</li>
                                                                                    </ul>
                                                                                </span>


                                                                            </span>
                                                                        </div>
                                                                        <div class="xl:col-span-4 col-span-12">

                                                                            <div class="xl:col-span-12 col-span-12">
                                                                                <div class="custom-toggle-switch sm:ms-2 ms-0">
                                                                                    <input id="authorizelavalidationdesdocuments" v-model="autorisationsystem.authorizelavalidationdesdocuments" type="checkbox" checked>
                                                                                    <label for="authorizelavalidationdesdocuments" class="label-primary mb-1"></label>
                                                                                </div>
                                                                            </div>


                                                                        </div>

                                                                    </div>

                                                                </div>




                                                                <!-- Fiche technique : moment du déstockage des matières premières et alertes de stock (bloc autonome) -->
                                                                <reglagefichetechnique ref="reglagefichetechnique"></reglagefichetechnique>

                                                                <div class=" block items-center mb-6 justify-between">
                                                                    <div class="grid grid-cols-12 gap-4">
                                                                        <div class="xl:col-span-4 col-span-12">
                                                                            <span class="text-[0.875rem] font-semibold mb-0">Utiliser la procédure de vente (Gestion commerciale) :</span>
                                                                        </div>
                                                                        <div class="xl:col-span-8 col-span-12">


                                                                            <div class="form-check !ps-0">
                                                                                <input class="form-check-input" type="radio"
                                                                                       v-model="autorisationsystem.authorizelaproceduredevente"
                                                                                       name="authorizelaproceduredevente"
                                                                                       value="1"
                                                                                       id="authorizelaproceduredevente1">
                                                                                <label class="form-check-label" for="authorizelaproceduredevente1">
                                                                                    1- Devis -> Bon de commande -> Bon de préparation de livraison -> Bon de livraison (MS) -> Facture (MS)
                                                                                </label>
                                                                            </div>


                                                                            <div class="form-check !ps-0">
                                                                                <input class="form-check-input" type="radio"
                                                                                       v-model="autorisationsystem.authorizelaproceduredevente"
                                                                                       name="authorizelaproceduredevente"
                                                                                       value="2"
                                                                                       id="authorizelaproceduredevente2">
                                                                                <label class="form-check-label" for="authorizelaproceduredevente2">
                                                                                    2- Devis -> Bon de commande -> Facture ->Bon de préparation de livraison -> Bon de livraison (MS)
                                                                                </label>
                                                                            </div>

                                                                            <div class="form-check !ps-0">
                                                                                <input class="form-check-input" type="radio"
                                                                                       v-model="autorisationsystem.authorizelaproceduredevente"
                                                                                       name="authorizelaproceduredevente"
                                                                                       value="3"
                                                                                       id="authorizelaproceduredevente3">
                                                                                <label class="form-check-label" for="authorizelaproceduredevente3">
                                                                                    3- Facture (Facturation de produits variés pour plusieurs magasins, principalement pour les clients des marchés(MS).)
                                                                                </label>
                                                                            </div>

                                                                            <div class="form-check !ps-0">
                                                                                <input class="form-check-input" type="radio"
                                                                                       v-model="autorisationsystem.authorizelaproceduredevente"
                                                                                       name="authorizelaproceduredevente"
                                                                                       value="4"
                                                                                       id="authorizelaproceduredevente4">
                                                                                <label class="form-check-label" for="authorizelaproceduredevente4">
                                                                                    4- Des dépôts sobebra avec la gestion des emballges(casier)
                                                                                </label>
                                                                            </div>





                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>

                                                     <div class="xl:col-span-12 col-span-12">
                                                     <div class="ltr:float-right rtl:float-left">

                                                         <button @click="Saveautorisationupdate" type="button" class="ti-btn bg-primary text-white m-1">
                                                             Enregistrer les modifications
                                                         </button>
                                                     </div>
                                                     </div>

                                                 </div>


                                                </div>








                                            </div>

                                            <div class="tab-pane !p-0 hidden" id="email-settings" aria-labelledby="email-item" role="tabpanel">

                                                <template v-if="Object.keys(datasignataire).length>0">

                                                <div class="grid grid-cols-12 gap-4">
                                                    <div class="xl:col-span-3 lg:col-span-3 md:col-span-3 sm:col-span-12 col-span-12">
                                                        <nav aria-label="Tabs" class="  block !justify-start whitespace-nowrap">

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary active"
                                                               @click="doctype='caisse'"
                                                               id="ddoccaisse" data-hs-tab="#doccaisse" aria-controls="doccaisse">
                                                                Caisse / Document
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='demandedachat'"
                                                               id="ddemandedachat" data-hs-tab="#demandedachat" aria-controls="demandedachat">
                                                                Achat / Demande d'achat
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='achatbcd'"
                                                               id="ddachatbcd" data-hs-tab="#achatbcd" aria-controls="achatbcd">
                                                                Achat / Bon de commande
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='achatbondereception'"
                                                               id="dachatbondereception" data-hs-tab="#achatbondereception" aria-controls="achatbondereception">
                                                                Achat / Bon de réception
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='achatfacture'"
                                                               id="dachatfacture" data-hs-tab="#achatfacture" aria-controls="achatfacture">
                                                                Achat / Facture
                                                            </a>
                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='achatfacture'"
                                                               id="dachatretoursurachat" data-hs-tab="#achatretoursurachat" aria-controls="achatretoursurachat">
                                                                Achat / Retour sur achat
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='vente_devis'"
                                                               id="dvente_devis" data-hs-tab="#vente_devis" aria-controls="vente_devis">
                                                                Vente / Devis
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='ventebcd'"
                                                               id="dventebcd" data-hs-tab="#ventebcd" aria-controls="ventebcd">
                                                                Vente / Bon de commande
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='ventebpl'"
                                                               id="dventebpl" data-hs-tab="#ventebpl" aria-controls="ventebpl">
                                                                Vente / Bon de préparation de livraison
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='ventebl'"
                                                               id="dventebl" data-hs-tab="#ventebl" aria-controls="ventebl">
                                                                Vente / Bon de livraison
                                                            </a>

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='ventef'"
                                                               id="dventef" data-hs-tab="#ventef" aria-controls="ventef">
                                                                Vente / Facture
                                                            </a>
                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem] flex-grow font-medium rounded-md
                                                            hover:text-primary "
                                                               @click="doctype='venteretourvente'"
                                                               id="dventeretourvente" data-hs-tab="#venteretourvente" aria-controls="venteretourvente">
                                                                Vente / retour sur vente
                                                            </a>


                                                        </nav>
                                                    </div>

                                                    <div class="xl:col-span-9 col-span-12">

                                                        <div class="tab-pane" id="doccaisse" aria-labelledby="ddoccaisse"
                                                             role="tabpanel">

                                                            <div class="alert alert-info text-center"> <h2>Caisse / Document de caisse</h2> </div>


                                                            <div class="grid grid-cols-12 gap-4 ">

                                                                <div class="xl:col-span-6 col-span-12 mt-3">
                                                                    <div class="form-group">
                                                                        <label >Titre du responsable des caisses</label>
                                                                        <input     v-model="datasignataire.caisseresponsable.titre"
                                                                                   type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 mt-3">
                                                                    <div class="form-group">
                                                                        <label >Nom du responsable des caisses</label>
                                                                        <input     v-model="datasignataire.caisseresponsable.name"
                                                                                   type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 mt-3">
                                                                    <div class="form-group">
                                                                        <label >Titre du responsable financier</label>
                                                                        <input     v-model="datasignataire.caisseresponsablefinancier.titre"
                                                                                   type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 mt-3">
                                                                    <div class="form-group">
                                                                        <label >Nom du responsable financier</label>
                                                                        <input     v-model="datasignataire.caisseresponsablefinancier.name"
                                                                                   type="text" class="form-control" >
                                                                    </div>
                                                                </div>






                                                            </div>




                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="demandedachat" aria-labelledby="ddemandedachat"
                                                             role="tabpanel">

                                                            <div class="alert alert-info text-center"> <h2>Achat / Demande d'achat</h2> </div>
                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12 ">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.demandedachat.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12 ">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12 ">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-3 col-span-12 ">
                                                                    <div class="form-group">
                                                                        <label  >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12  mb-3">  <button @click="ajouterline(datasignataire.demandedachat.signataires)" class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12 ">
                                                                    <table class="table table-responsive table-bordered w-full">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.demandedachat.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.demandedachat.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.demandedachat.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.demandedachat.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>

                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="achatbcd" aria-labelledby="dachatbcd"
                                                             role="tabpanel">

                                                            <div class="alert alert-info text-center"> <h2>Achat / Bon de commande</h2> </div>

                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.achatbcd.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.achatbcd.signataires)"
                                                                class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered w-full">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.achatbcd.signataires.length" >
                                                                            <tr v-for="(datavalue,index) in datasignataire.achatbcd.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.achatbcd.signataires,index)"
                                                                                            :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.achatbcd.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>




                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="achatbondereception" aria-labelledby="dachatbondereception"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Achat / Bon de réception</h2> </div>

                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.achatbondereception.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.achatbondereception.signataires)" class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.achatbondereception.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.achatbondereception.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.achatbondereception.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.achatbondereception.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>






                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="achatfacture" aria-labelledby="dachatfacture"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Achat / Facture</h2> </div>

                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.achatfacture.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.achatfacture.signataires)" class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered w-full">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.achatfacture.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.achatfacture.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.achatfacture.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.achatfacture.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>






                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="achatretoursurachat" aria-labelledby="dachatretoursurachat"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Achat / Retour sur achat</h2> </div>


                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.achatretour.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.achatretour.signataires)" class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.achatretour.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.achatretour.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.achatretour.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.achatretour.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>









                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="vente_devis" aria-labelledby="dvente_devis"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Vente / Devis</h2> </div>

                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.ventedevis.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12mb-3">  <button @click="ajouterline(datasignataire.ventedevis.signataires)" class="ti-btn ti-btn-primary-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.ventedevis.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.ventedevis.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.ventedevis.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.ventedevis.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>












                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="ventebcd" aria-labelledby="dventebcd"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Vente / Bon de commande</h2> </div>


                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.ventebcd.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12" v-if="$store.state.authorizelavalidationdesdocuments===0 || $store.state.authorizelavalidationdesdocuments==='0'">
                                                                    <div class="form-group">
                                                                        <label >Nom du signataire </label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>

                                                                <!--div class="xl:col-span-4 col-span-12" v-else>
                                                                    <div class="form-group">

                                                                        <label >Nom du signataire </label>
                                                                        <select v-model="jsonmnomsignataire" class="form-control">
                                                                            <option value="">Veuillez séléctionner un signataire</option>
                                                                            <option v-for="signataire in datausers" :value="signataire">{{signataire.name}}</option>
                                                                        </select>

                                                                    </div>
                                                                </div-->



                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Url signature électronique</label>
                                                                        <input     v-model="urlfilesignataire" disabled type="text" class="form-control" >

                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.ventebcd.signataires)" class="ti-btn ti-btn-primary mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.ventebcd.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.ventebcd.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >
                                                                                    <a v-if="datavalue.msignaturesignataire!==''" :href="datavalue.msignaturesignataire" target="_blank">
                                                                                        <img :src="datavalue.msignaturesignataire" style="width: 80px" alt="">
                                                                                    </a>
                                                                                </td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.ventebcd.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.ventebcd.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>














                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="ventebpl" aria-labelledby="dventebpl"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Vente / Bon de préparation de livraison</h2> </div>


                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.ventebpl.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.ventebpl.signataires)" class="ti-btn ti-btn-primary w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.ventebpl.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.ventebpl.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.ventebpl.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.ventebpl.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>


                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="ventebl" aria-labelledby="dventebl"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Vente / Bon de livraison</h2> </div>

                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.ventebl.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.ventebl.signataires)" class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.ventebl.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.ventebl.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.ventebl.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.ventebl.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>





                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="ventef" aria-labelledby="dventef"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Vente / Facture</h2> </div>

                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.ventefacture.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.ventefacture.signataires)" class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered w-full">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.ventefacture.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.ventefacture.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.ventefacture.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.ventefacture.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>





                                                        </div>

                                                        <div class="tab-pane hidden"
                                                             id="venteretourvente" aria-labelledby="dventeretourvente"
                                                             role="tabpanel">
                                                            <div class="alert alert-info text-center"> <h2>Vente / retour sur vente</h2> </div>


                                                            <div class="grid grid-cols-12 gap-4">
                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="form-group">
                                                                        <label  >Titre du document</label>
                                                                        <input    v-model="datasignataire.venteretour.titredoc" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Titre du signataire</label>
                                                                        <input    v-model="mtitresignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Nom du signataire</label>
                                                                        <input     v-model="mnomsignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div>
                                                                <!--div class="xl:col-span-4 col-span-12">
                                                                    <div class="form-group">
                                                                        <label >Url signature électronique</label>
                                                                        <input     v-model="msignaturesignataire" type="text" class="form-control" >
                                                                    </div>
                                                                </div-->

                                                                <div class="xl:col-span-4 col-span-12 mb-3">  <button @click="ajouterline(datasignataire.venteretour.signataires)" class="ti-btn ti-btn-primary-full w-full mt-4">Ajouter</button></div>
                                                                <div class="clearfix"></div>

                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <table class="table table-responsive table-bordered w-full">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>Titre du signataire</th>
                                                                            <th>Nom du signataire</th>
                                                                            <th>Signature électronique</th>
                                                                            <th>Action</th>
                                                                        </tr>

                                                                        </thead>
                                                                        <tbody>
                                                                        <template v-if="datasignataire.venteretour.signataires.length">
                                                                            <tr v-for="(datavalue,index) in datasignataire.venteretour.signataires" :key="index">
                                                                                <td data-label="Titre du signataire  : " >{{datavalue.mtitresignataire}}</td>
                                                                                <td data-label="Nom du signataire  : " >{{datavalue.mnomsignataire}}</td>
                                                                                <td data-label="Signature électronique  : " >{{datavalue.msignaturesignataire}}</td>
                                                                                <td data-label="Action:">
                                                                                    <button @click="retirerline(datasignataire.venteretour.signataires,index)" :title="'retirer '+datavalue.mtitresignataire" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>
                                                                            </tr>
                                                                        </template>
                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="8"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>
                                                                        </template>
                                                                        </tbody>
                                                                    </table>
                                                                </div>





                                                                <div class="xl:col-span-6 col-span-12 mb-3">
                                                                    <label >Document d'édition</label>
                                                                    <select v-model="datasignataire.venteretour.document" class="form-control" >
                                                                        <option value="0">Document par défaut</option>
                                                                        <option :disabled="nbrededocumentactive<1" value="1">Document 1</option>
                                                                        <option :disabled="nbrededocumentactive<2" value="2">Document 2</option>
                                                                        <option :disabled="nbrededocumentactive<3" value="3">Document 3</option>
                                                                        <option :disabled="nbrededocumentactive<4" value="4">Document 4</option>
                                                                        <option :disabled="nbrededocumentactive<5" value="5">Document 5</option>
                                                                    </select>
                                                                </div>
                                                                <div class="xl:col-span-6 col-span-12 ">
                                                                    <a :href="urletatpicture" target="_blank">
                                                                        <img  class="img-responsive imgsize" :src="urletatpicture" alt="">
                                                                    </a>
                                                                </div>
                                                            </div>





                                                        </div>





                                                    </div>


                                                    <div class="xl:col-span-12 col-span-12">
                                                        <div class="ltr:float-right rtl:float-left">

                                                            <button @click="Savesignataire" type="button" class="ti-btn bg-primary text-white m-1">
                                                                Enregistrer les modifications
                                                            </button>
                                                        </div>
                                                    </div>

                                                </div>



                                                </template>



                                            </div>

                                            <div class="tab-pane hidden" id="labels" aria-labelledby="labels-item" role="tabpanel">

                                                <div class="grid grid-cols-12 gap-4">

                                                    <div class="xl:col-span-6 col-span-12">

                                                        <div class="form-group">
                                                            <label class="input input--file">
                                                                <span class="input__text">Fichier <sup title="required">*</sup></span>
                                                                <input type="file" id="file" ref="file" v-on:change="previewImage" class="input__field" accept="image/*" required>
                                                                <span class="input__support">
                                                                    <span class="input__helper"></span>
                                                                  </span>
                                                            </label>
                                                        </div>


                                                        <div class="form-group">
                                                            <label >Titre </label>
                                                            <input type="text" class="form-control" v-model="titreuploadsignature">
                                                        </div>


                                                    </div>
                                                    <div class="xl:col-span-6 col-span-12">

                                                        <div class="border p-2 mt-3">
                                                            <p>Aperçu du fichier :</p>
                                                            <template v-if="preview">
                                                                <img :src="preview" class="img-fluid" />
                                                                <p class="mb-0">Nom du fichier: {{ image.name }}</p>
                                                                <p class="mb-0">Taille du fichier: {{ image.size/1024 }}KB</p>


                                                                <div class="xl:col-span-12 col-span-12 mt-7">
                                                                    <div class="progress progress-xs">
                                                                        <div class="progress-bar !bg-info" :style="`width: ${uploadPercentage}%`" role="progressbar" :aria-valuenow="uploadPercentage" aria-valuemin="0" aria-valuemax="100"> </div>
                                                                    </div>

                                                                    <h3 ref="status" id="status"></h3>
                                                                    <p ref="loaded_n_total" id="loaded_n_total"></p>
                                                                </div>



                                                            </template>
                                                        </div>



                                                    </div>


                                                    <div class="xl:col-span-12 col-span-12" style="margin-top: 20px;margin-bottom: 20px">

                                                        <button class="ti-btn ti-btn-primary-full w-full" v-on:click="SaveUploadsignature()"><i class="ri-upload-2-fill"></i> Télécharger</button>
                                                    </div>


                                                    <div class="xl:col-span-12 col-span-12 mt-3" style="height: 100%;">
                                                        <div class="xl:col-span-12 col-span-12 mt-3 tableFixHead">
                                                            <table class="table table-striped table-bordered table-hover dataTable no-footer dtr-inline mytable w-full">
                                                                <thead>
                                                                <tr>
                                                                    <th>N°</th>
                                                                    <th>Titre</th>
                                                                    <th>Url</th>
                                                                    <th>Image signature</th>
                                                                    <th>Action</th>

                                                                </tr>
                                                                </thead>


                                                                <tbody>
                                                                <template v-if="filterdatableuploadsignature.length">


                                                                    <tr style="font-weight: 600;/*background: khaki;*/"
                                                                        v-for="(datavalue,index) in filterdatableuploadsignature" :key="index">

                                                                        <td  data-label="N°  : "   >{{ index+1 }}</td>
                                                                        <td  data-label="Utilisateur  : "   >{{ (datavalue.tsignature) }}</td>
                                                                        <td  data-label="Url : "   >{{$store.state.baseurlapifile+datavalue.file }}</td>
                                                                        <td  data-label="Image signature : "   >
                                                                            <a :href="$store.state.baseurlapifile+datavalue.file" target="_blank">
                                                                                <img :src="$store.state.baseurlapifile+datavalue.file" alt="" style="width: 100px">
                                                                            </a>
                                                                        </td>
                                                                        <td v-if="datavalue.useline===0" data-label="Action  : "  >
                                                                            <button @click="deletelinesignatureUpload(datavalue)"   class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                        </td>
                                                                        <td v-else data-label="Action  : "  >
                                                                        </td>


                                                                    </tr>


                                                                </template>



                                                                <template v-else>
                                                                    <tr >
                                                                        <td colspan="7"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                    </tr>

                                                                </template>




                                                                </tbody>

                                                            </table>

                                                        </div>
                                                    </div>









                                                </div>

                                            </div>

                                            <div class="tab-pane hidden" id="gestnotification" aria-labelledby="labels-notification" role="tabpanel">


                                                <div class="grid grid-cols-12 gap-4">
                                                    <div class="xl:col-span-3 lg:col-span-3 md:col-span-3 sm:col-span-12 col-span-12">
                                                        <nav aria-label="Tabs" class="  block !justify-start whitespace-nowrap">

                                                            <a class="m-1 block w-full hs-tab-active:bg-primary/10 hs-tab-active:text-primary
                                                            cursor-pointer text-defaulttextcolor py-2 px-3 text-[0.75rem]
                                                            flex-grow font-medium rounded-md
                                                            hover:text-primary active"

                                                               id="dutilisationnotification" data-hs-tab="#utilisationnotification" aria-controls="utilisationnotification">
                                                                Utilisateur -> Type notification
                                                            </a>


                                                        </nav>
                                                    </div>

                                                    <div class="xl:col-span-9 col-span-12">

                                                        <div class="tab-pane" id="utilisationnotification" aria-labelledby="dutilisationnotification"
                                                             role="tabpanel">

                                                        <div class="grid grid-cols-12 gap-4">

                                                            <div class="xl:col-span-6 col-span-12">

                                                                <div class="space-y-2">
                                                                    <label class="text-capitalize ti-form-label mb-0">Utilisateur</label>
                                                                    <select v-model="notification.username" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm
                                                                    !py-2 !px-3">
                                                                        <option :value="null">Sélectionner un utilisateur</option>
                                                                        <option v-for="(user,index) of alldatanotification.users" :value="user" :key="index">{{user.username}}</option>

                                                                    </select>
                                                                </div>


                                                            </div>
                                                            <div class="xl:col-span-6 col-span-12">


                                                                <div class="space-y-2">
                                                                    <label class="text-capitalize ti-form-label mb-0">Type de notification</label>
                                                                    <select v-model="notification.tpnotif" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm
                                                                    !py-2 !px-3">
                                                                        <option :value="null">Sélectionner une notification</option>
                                                                        <option v-for="(notif,index) of alldatanotification.tpnotif" :value="notif" :key="index">{{notif.name}}</option>

                                                                    </select>
                                                                </div>


                                                            </div>

                                                             <div class="xl:col-span-12 col-span-12" style="margin-top: 20px;margin-bottom: 20px">
                                                                        <button @click="ajouterlinetonotification" class="ti-btn ti-btn-primary-full w-full" >
                                                                            <i class="ri-add-box-fill"></i> Ajouter</button>
                                                              </div>

                                                                <div class="xl:col-span-12 col-span-12" style="margin-top: 20px;margin-bottom: 20px">

                                                                    <table class="table table-striped table-bordered table-hover
                                                                    dataTable no-footer dtr-inline mytable w-full">
                                                                        <thead>
                                                                        <tr>
                                                                            <th>N°</th>
                                                                            <th>Utilisateur</th>
                                                                            <th>Type de notification</th>
                                                                            <th>Action</th>

                                                                        </tr>
                                                                        </thead>


                                                                        <tbody>
                                                                        <template v-if="filterdatablelistenotification.length">

                                                                            <tr style="font-weight: 600;/*background: khaki;*/"
                                                                                v-for="(datavalue,index) in filterdatablelistenotification" :key="index">

                                                                                <td  data-label="N°  : "   >{{ index+1 }}</td>
                                                                                <td  data-label="Utilisateur  : "   >{{ (datavalue.username) }}</td>
                                                                                <td  data-label="Type de notification  : "   >{{ datavalue.notif.name }}</td>
                                                                                <td data-label="Action  : "  >
                                                                                    <button @click="deletelinenotification(datavalue)" class="ti-btn ti-btn-danger-full w-full"><i class="ri-delete-row"></i></button>
                                                                                </td>


                                                                            </tr>


                                                                        </template>



                                                                        <template v-else>
                                                                            <tr >
                                                                                <td colspan="7"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                                            </tr>

                                                                        </template>




                                                                        </tbody>

                                                                    </table>


                                                                </div>







                                                        </div>
                                                        </div>


                                                    </div>
                                                </div>





                                            </div>

                                            <div class="tab-pane hidden" id="gestlibelle" aria-labelledby="labels-libelle" role="tabpanel">


                                                <div class="grid grid-cols-12 gap-4">

                                                    <div class="xl:col-span-12 col-span-12">

                                                        <div class="space-y-2">
                                                            <label class="text-capitalize ti-form-label mb-0">Type de libellé / formulaire</label>
                                                            <select v-model="selectedItemslibelle" class="my-auto ti-form-input  rounded-sm ti-form-select rounded-sm
                                                                    !py-2 !px-3">
                                                                <option :value="null">Sélectionner un type</option>
                                                                <option v-for="(line,index) of alldatalibelle" :key="index" :value="line">{{line.linename}}</option>
                                                            </select>
                                                        </div>


                                                    </div>



                                                    <div class="xl:col-span-12 col-span-12" style="margin-top: 20px;margin-bottom: 20px">

                                                        <template v-if="selectedItemslibelle!==null">
                                                            <template v-if="selectedItemslibelle.dataline.typform==='prixdevente'">

                                                                <table class="table table-striped table-bordered table-hover
                                                                dataTable no-footer dtr-inline mytable w-full">
                                                                    <thead>
                                                                    <tr>
                                                                        <th>N°</th>
                                                                        <th>Libellé par défaut</th>
                                                                        <th>Libellé personnalisé</th>

                                                                    </tr>
                                                                    </thead>


                                                                    <tbody>


                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >1</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente"></td>

                                                                    </tr>

                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >2</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente1) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente1"></td>

                                                                    </tr>

                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >3</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente2) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente2"></td>

                                                                    </tr>

                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >4</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente3) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente3"></td>

                                                                    </tr>

                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >5</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente4) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente4"></td>

                                                                    </tr>

                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >6</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente5) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente5"></td>

                                                                    </tr>

                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >7</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente6) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente6"></td>

                                                                    </tr>

                                                                    <tr style="font-weight: 600;/*background: khaki;*/" >

                                                                        <td class="text-center"  data-label="N°  : "   >8</td>
                                                                        <td  data-label="Libellé par défaut  : "   >{{ (selectedItemslibelle.linedefault.prixvente7) }}</td>
                                                                        <td  data-label="Libellé personnalisé : "   ><input type="text" class="form-control"
                                                                                                                            v-model="selectedItemslibelle.dataline.valuedata.prixvente7"></td>

                                                                    </tr>




                                                                    </tbody>

                                                                </table>



                                                                <div class="xl:col-span-12 col-span-12">
                                                                    <div class="ltr:float-right rtl:float-left">

                                                                        <button @click="Savelinenotification" type="button" class="ti-btn bg-primary text-white m-1">
                                                                            Enregistrer les modifications
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                            </template>
                                                        </template>
                                                    </div>







                                                </div>



                                            </div>

                                            <!-- ===================== ONGLET : GESTION TOKEN NORMALISATION ===================== -->
                                            <div class="tab-pane hidden" id="gesttokennormalisation" aria-labelledby="labels-tokenormalisation" role="tabpanel">

                                                <div class="grid grid-cols-12 gap-6">

                                                    <!-- Titre de la section -->
                                                    <div class="xl:col-span-12 col-span-12">
                                                        <div class="alert alert-info flex items-center gap-3 mb-0">
                                                            <i class="ri-shield-keyhole-line text-2xl"></i>
                                                            <div>
                                                                <h5 class="mb-0 font-semibold">Token de normalisation DGI</h5>
                                                                <p class="mb-0 text-[0.8rem]">Le token enregistré est chargé automatiquement et vérifié auprès de la DGI. Il n'est jamais affiché en entier.</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Chargement -->
                                                    <div class="xl:col-span-12 col-span-12" v-if="tokennormalisation.loading && !tokennormalisation.loaded">
                                                        <div class="text-center p-6 text-muted">
                                                            <i class="ri-loader-4-line animate-spin text-2xl me-2"></i> Chargement du token...
                                                        </div>
                                                    </div>

                                                    <!-- Token enregistré (masqué, lecture seule) -->
                                                    <div class="xl:col-span-12 col-span-12" v-if="tokennormalisation.loaded && tokennormalisation.exists">
                                                        <label class="ti-form-label font-semibold">Token enregistré (masqué pour des raisons de sécurité)</label>
                                                        <input type="text" class="form-control w-full font-mono" :value="tokennormalisation.maskedToken" readonly>
                                                    </div>

                                                    <!-- Zone de saisie d'un (nouveau) token -->
                                                    <div class="xl:col-span-12 col-span-12" v-if="tokennormalisation.loaded && (!tokennormalisation.exists || tokennormalisation.editmode)">
                                                        <label class="ti-form-label font-semibold">{{ tokennormalisation.exists ? 'Nouveau token de normalisation' : 'Token de normalisation' }} <sup class="text-danger">*</sup></label>
                                                        <textarea
                                                            v-model="tokennormalisation.token"
                                                            class="form-control w-full"
                                                            rows="5"
                                                            placeholder="Collez ici votre token de normalisation..."
                                                            :disabled="tokennormalisation.loading"
                                                        ></textarea>
                                                    </div>

                                                    <!-- Bouton vérifier + enregistrer -->
                                                    <div class="xl:col-span-12 col-span-12" v-if="tokennormalisation.loaded && (!tokennormalisation.exists || tokennormalisation.editmode)">
                                                        <button
                                                            @click="verifierEtEnregistrerTokenNormalisation(false)"
                                                            type="button"
                                                            class="ti-btn bg-primary text-white"
                                                            :disabled="tokennormalisation.loading || !tokennormalisation.token.trim()"
                                                        >
                                                            <span v-if="tokennormalisation.loading">
                                                                <i class="ri-loader-4-line animate-spin me-1"></i> Traitement en cours...
                                                            </span>
                                                            <span v-else>
                                                                <i class="ri-shield-check-line me-1"></i> Vérifier et enregistrer
                                                            </span>
                                                        </button>
                                                    </div>

                                                    <!-- Bouton Modifier (token valide non modifiable) -->
                                                    <div class="xl:col-span-12 col-span-12" v-if="tokennormalisation.loaded && tokennormalisation.exists && !tokennormalisation.modifiable && !tokennormalisation.editmode">
                                                        <button @click="ouvrirModalSupportToken" type="button" class="ti-btn ti-btn-secondary">
                                                            <i class="ri-edit-line me-1"></i> Modifier le token
                                                        </button>
                                                    </div>

                                                    <!-- Résultat / Statut -->
                                                    <div class="xl:col-span-12 col-span-12" v-if="tokennormalisation.loaded && tokennormalisation.exists && tokennormalisation.statut">

                                                        <!-- Statut global : badge -->
                                                        <div :class="['alert flex items-start gap-4 p-4 rounded-lg border',
                                                            tokennormalisation.statut === 'valide'   ? 'alert-success border-success/30' :
                                                            tokennormalisation.statut === 'expire'   ? 'alert-warning border-warning/30' :
                                                                                                       'alert-danger  border-danger/30'
                                                        ]">
                                                            <i :class="[
                                                                'text-3xl mt-1',
                                                                tokennormalisation.statut === 'valide'  ? 'ri-checkbox-circle-line text-success' :
                                                                tokennormalisation.statut === 'expire'  ? 'ri-time-line text-warning' :
                                                                                                           'ri-close-circle-line text-danger'
                                                            ]"></i>
                                                            <div>
                                                                <p class="font-bold text-[1rem] mb-1">
                                                                    <span v-if="tokennormalisation.statut === 'valide'">Token valide</span>
                                                                    <span v-else-if="tokennormalisation.statut === 'expire'">Token expiré</span>
                                                                    <span v-else>Token invalide</span>
                                                                </p>
                                                                <p class="mb-0 text-[0.85rem]">
                                                                    <span v-if="tokennormalisation.statut === 'valide'">Ce token est valide. Il expire dans {{ tokennormalisation.joursRestants }} jour(s).</span>
                                                                    <span v-else-if="tokennormalisation.statut === 'expire'">Ce token est expiré. Veuillez contacter la DGI / le support pour le renouveler.</span>
                                                                    <span v-else>Token invalide ou non reconnu par la DGI.</span>
                                                                </p>
                                                            </div>
                                                        </div>

                                                      <!-- Détails du token -->
                                                      <div class="box shadow-none border mt-4" v-if="tokennormalisation.details">
                                                        <div class="box-header">
                                                          <h5 class="box-title font-semibold">
                                                            <i class="ri-information-line me-1"></i> Détails du token
                                                          </h5>
                                                        </div>
                                                        <div class="box-body">
                                                          <!-- Grille d'informations générales -->
                                                          <div class="grid grid-cols-12 gap-4 mb-4">
                                                            <div class="xl:col-span-3 col-span-12">
                                                              <div class="p-3 bg-light rounded-lg text-center">
                                                                <p class="text-[0.75rem] text-muted mb-1">IFU (Contribuable)</p>
                                                                <p class="font-bold mb-0">{{ tokennormalisation.details.ifu || 'Non renseigné' }}</p>
                                                              </div>
                                                            </div>

                                                            <div class="xl:col-span-3 col-span-12">
                                                              <div class="p-3 bg-light rounded-lg text-center">
                                                                <p class="text-[0.75rem] text-muted mb-1">NIM</p>
                                                                <p class="font-bold mb-0">{{ tokennormalisation.details.nim || 'Non renseigné' }}</p>
                                                              </div>
                                                            </div>

                                                            <div class="xl:col-span-3 col-span-12">
                                                              <div class="p-3 bg-light rounded-lg text-center">
                                                                <p class="text-[0.75rem] text-muted mb-1">Date d'expiration</p>
                                                                <p class="font-bold mb-0">{{ formatDateOnly(tokennormalisation.details.dateExpiration) }}</p>
                                                              </div>
                                                            </div>

                                                            <div class="xl:col-span-3 col-span-12">
                                                              <div class="p-3 bg-light rounded-lg text-center">
                                                                <p class="text-[0.75rem] text-muted mb-1">Jours restants</p>
                                                                <p class="font-bold mb-0" :class="{
                                                                                    'text-danger': tokennormalisation.details.joursRestants <= 0,
                                                                                    'text-warning': tokennormalisation.details.joursRestants > 0 && tokennormalisation.details.joursRestants <= 30,
                                                                                    'text-success': tokennormalisation.details.joursRestants > 30
                                                                                }">
                                                                  {{ tokennormalisation.details.joursRestants <= 0 ? 'Expiré' : tokennormalisation.details.joursRestants + ' jours' }}
                                                                </p>
                                                              </div>
                                                            </div>

                                                            <div class="xl:col-span-3 col-span-12">
                                                              <div class="p-3 bg-light rounded-lg text-center">
                                                                <p class="text-[0.75rem] text-muted mb-1">Type de token</p>
                                                                <p class="font-bold mb-0">{{ tokennormalisation.details.type || 'Normalisation DGI' }}</p>
                                                              </div>
                                                            </div>

                                                            <div class="xl:col-span-3 col-span-12">
                                                              <div class="p-3 bg-light rounded-lg text-center">
                                                                <p class="text-[0.75rem] text-muted mb-1">Environnement</p>
                                                                <p class="font-bold mb-0">
                                                                                <span :class="[
                                                                                    'badge',
                                                                                    tokennormalisation.details.environnement === 'production'
                                                                                        ? 'bg-success/20 text-success'
                                                                                        : 'bg-warning/20 text-warning'
                                                                                ]">
                                                                                    {{ tokennormalisation.details.environnement || 'production' }}
                                                                                </span>
                                                                </p>
                                                              </div>
                                                            </div>

                                                            <div class="xl:col-span-3 col-span-12">
                                                              <div class="p-3 bg-light rounded-lg text-center">
                                                                <p class="text-[0.75rem] text-muted mb-1">Dernière vérification</p>
                                                                <p class="font-bold mb-0">{{ formatDateTime(tokennormalisation.details.lastVerification) }}</p>
                                                              </div>
                                                            </div>
                                                          </div>

                                                          <!-- Liste des établissements EMCF -->
                                                          <div v-if="tokennormalisation.details.emcf && tokennormalisation.details.emcf.length">
                                                            <div class="flex items-center justify-between mb-3">
                                                              <h5 class="font-semibold">
                                                                <i class="ri-store-line me-1"></i> Établissements rattachés (EMCF)
                                                                <span class="badge bg-primary/10 text-primary ms-2">{{ tokennormalisation.details.nbEtablissements }}</span>
                                                              </h5>
                                                            </div>

                                                            <div class="table-responsive">
                                                              <table class="table min-w-full table-bordered">
                                                                <thead>
                                                                <tr>
                                                                  <th>NIM</th>
                                                                  <th>Statut</th>
                                                                  <th>Adresse</th>
                                                                  <th>Contact principal</th>
                                                                  <th>Email / Contact secondaire</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr v-for="(emcf, idx) in tokennormalisation.details.emcf" :key="idx">
                                                                  <td class="font-mono text-sm">{{ emcf.nim }}</td>
                                                                  <td>
                                                                    <span :class="[
                                                                        'badge',
                                                                        emcf.status === 'Actif' ? 'bg-success/20 text-success' : 'bg-danger/20 text-danger'
                                                                    ]">
                                                                        {{ emcf.status }}
                                                                    </span>
                                                                  </td>
                                                                  <td>{{ emcf.address || 'Non renseignée' }}</td>
                                                                  <td>{{ emcf.contact1 || '-' }}</td>
                                                                  <td>
                                                                    {{ emcf.contact2 || '-' }}
                                                                    <span v-if="emcf.contact3"> / {{ emcf.contact3 }}</span>
                                                                  </td>
                                                                </tr>
                                                                </tbody>
                                                              </table>
                                                            </div>
                                                          </div>
                                                          <div v-else-if="tokennormalisation.details.emcf && tokennormalisation.details.emcf.length === 0"
                                                               class="alert alert-light text-center">
                                                            <i class="ri-information-line me-1"></i> Aucun établissement enregistré pour ce token.
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                </div>

                                                <!-- ===== MODAL CONTACTER LE SUPPORT (modification token) ===== -->
                                                <div v-if="tokennormalisation.modalSupportVisible"
                                                     class="fixed inset-0 z-[9999] flex items-center justify-center"
                                                     style="background: rgba(0,0,0,0.55);">
                                                    <div class="bg-white rounded-lg shadow-2xl w-full max-w-lg mx-4">

                                                        <div class="flex items-center justify-between px-5 py-4 border-b bg-info/10">
                                                            <div class="flex items-center gap-2">
                                                                <i class="ri-customer-service-2-line text-xl text-info"></i>
                                                                <h6 class="mb-0 font-bold text-info">Modification du token</h6>
                                                            </div>
                                                            <button @click="fermerModalSupportToken" class="text-gray-400 hover:text-gray-600">
                                                                <i class="ri-close-line text-xl"></i>
                                                            </button>
                                                        </div>

                                                        <div class="px-5 py-5">
                                                            <div class="alert alert-info mb-0 text-[0.85rem]">
                                                                <i class="ri-information-line me-1"></i>
                                                                Le token actuel est encore <strong>valide</strong>. Pour des raisons de sécurité,
                                                                sa modification n'est pas autorisée depuis cette interface.
                                                                <br><br>
                                                                Veuillez <strong>contacter le support</strong> pour vous aider dans la modification du token.
                                                            </div>
                                                        </div>

                                                        <div class="flex justify-end gap-2 px-5 py-4 border-t">
                                                            <button @click="fermerModalSupportToken" type="button" class="ti-btn ti-btn-primary">
                                                                <i class="ri-check-line me-1"></i> J'ai compris
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                                <!-- ===== FIN MODAL SUPPORT ===== -->

                                            </div>
                                            <!-- ===================== FIN ONGLET TOKEN NORMALISATION ===================== -->

                                            <!-- ===================== ONGLET APPAREILS SERVEURS ===================== -->
                                            <div class="tab-pane hidden" id="gestserveurdevices" aria-labelledby="labels-serveurdevices" role="tabpanel">
                                                <div class="grid grid-cols-12 gap-6">
                                                    <div class="xl:col-span-12 col-span-12">
                                                        <serveurdevices ref="serveurdevicesref" />
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- ===================== FIN ONGLET APPAREILS SERVEURS ===================== -->

                                            <!-- ===================== ONGLET UTILISATEURS CONNECTÉS ===================== -->
                                            <div class="tab-pane hidden" id="gestusersconnectes" aria-labelledby="labels-usersconnectes" role="tabpanel">
                                                <div class="grid grid-cols-12 gap-6">
                                                    <div class="xl:col-span-12 col-span-12">
                                                        <utilisateursconnectes ref="usersconnectesref" />
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- ===================== FIN ONGLET UTILISATEURS CONNECTÉS ===================== -->

                                            <!-- ===================== ONGLET LIENS COURTS ===================== -->
                                            <div class="tab-pane hidden" id="gestshortlinks" aria-labelledby="labels-shortlinks" role="tabpanel">
                                                <div class="grid grid-cols-12 gap-6">
                                                    <div class="xl:col-span-12 col-span-12">
                                                        <shortlinks ref="shortlinksref" />
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- ===================== FIN ONGLET LIENS COURTS ===================== -->

                                            <!-- ===================== ONGLET AUDIT PANIERS ===================== -->
                                            <div class="tab-pane hidden" id="gestauditpaniers" aria-labelledby="labels-auditpaniers" role="tabpanel">
                                                <div class="grid grid-cols-12 gap-6">
                                                    <div class="xl:col-span-12 col-span-12">
                                                        <auditpaniers ref="auditpaniersref" />
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- ===================== FIN ONGLET AUDIT PANIERS ===================== -->

                                            <!-- ===================== ONGLET RÉINITIALISATION BASE ===================== -->
                                            <div class="tab-pane hidden" id="gestreinitialisation" aria-labelledby="labels-reinitialisation" role="tabpanel">

                                                <div class="grid grid-cols-12 gap-6">

                                                    <!-- Alerte générale -->
                                                    <div class="xl:col-span-12 col-span-12">
                                                        <div class="alert alert-danger flex items-start gap-3">
                                                            <i class="ri-error-warning-fill text-2xl mt-0.5"></i>
                                                            <div>
                                                                <p class="font-bold mb-1">Attention - opération irréversible</p>
                                                                <p class="mb-0 text-[0.8rem]">
                                                                    Toute réinitialisation supprime définitivement les données sélectionnées.
                                                                    Un texte de sécurité vous sera demandé pour confirmer l'opération.
                                                                    <strong>Aucune restauration ne sera possible.</strong>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Carte : Réinitialisation partielle -->
                                                    <div class="xl:col-span-6 col-span-12">
                                                        <div class="box border border-warning/40 h-full">
                                                            <div class="box-header bg-warning/10">
                                                                <div class="flex items-center gap-2">
                                                                    <i class="ri-refresh-line text-warning text-xl"></i>
                                                                    <h6 class="box-title text-warning font-bold mb-0">Réinitialisation partielle</h6>
                                                                </div>
                                                            </div>
                                                            <div class="box-body">
                                                                <p class="text-[0.85rem] mb-3 font-semibold">Articles conservés - stocks remis à zéro</p>
                                                                <p class="text-[0.8rem] text-[#8c9097] mb-3">
                                                                    Cette opération conserve votre catalogue d'articles mais efface toutes les transactions.
                                                                </p>
                                                                <p class="text-[0.8rem] font-semibold mb-2">Données supprimées :</p>
                                                                <ul class="text-[0.8rem] text-[#8c9097] list-disc ps-4 mb-4 space-y-1">
                                                                    <li>Tous les mouvements de stock</li>
                                                                    <li>Inventaires et ajustements</li>
                                                                    <li>Documents de vente (devis, BCD, BPL, BL, factures, retours)</li>
                                                                    <li>Documents d'achat (demandes, BCD, BR, factures, retours)</li>
                                                                    <li>Règlements, encaissements et décaissements</li>
                                                                    <li>Historique des notifications</li>
                                                                </ul>
                                                                <p class="text-[0.8rem] font-semibold text-success mb-2">Données conservées :</p>
                                                                <ul class="text-[0.8rem] text-success/80 list-disc ps-4 mb-4 space-y-1">
                                                                    <li>Articles et catégories</li>
                                                                    <li>Clients et fournisseurs</li>
                                                                    <li>Utilisateurs et paramètres système</li>
                                                                    <li>Signataires et configurations</li>
                                                                </ul>
                                                                <button @click="ouvrirModalReinit('partielle')"
                                                                        type="button"
                                                                        class="ti-btn bg-warning text-white w-full">
                                                                    <i class="ri-refresh-line me-1"></i>
                                                                    Réinitialiser (partielle)
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Carte : Réinitialisation totale -->
                                                    <div class="xl:col-span-6 col-span-12">
                                                        <div class="box border border-danger/40 h-full">
                                                            <div class="box-header bg-danger/10">
                                                                <div class="flex items-center gap-2">
                                                                    <i class="ri-delete-bin-2-fill text-danger text-xl"></i>
                                                                    <h6 class="box-title text-danger font-bold mb-0">Réinitialisation totale</h6>
                                                                </div>
                                                            </div>
                                                            <div class="box-body">
                                                                <p class="text-[0.85rem] mb-3 font-semibold">Remise à zéro complète de la base</p>
                                                                <p class="text-[0.8rem] text-[#8c9097] mb-3">
                                                                    Tout est effacé. La base retrouve l'état d'une installation vierge.
                                                                </p>
                                                                <p class="text-[0.8rem] font-semibold mb-2">Données supprimées :</p>
                                                                <ul class="text-[0.8rem] text-[#8c9097] list-disc ps-4 mb-4 space-y-1">
                                                                    <li>Articles, catégories, dépôts</li>
                                                                    <li>Clients, fournisseurs, contacts</li>
                                                                    <li>Tous les mouvements de stock</li>
                                                                    <li>Documents de vente et d'achat</li>
                                                                    <li>Règlements, encaissements et décaissements</li>
                                                                    <li>Personnel et contrats</li>
                                                                    <li>Historique complet de toutes les opérations</li>
                                                                </ul>
                                                                <p class="text-[0.8rem] font-semibold text-success mb-2">Données conservées :</p>
                                                                <ul class="text-[0.8rem] text-success/80 list-disc ps-4 mb-4 space-y-1">
                                                                    <li>Utilisateurs et droits d'accès</li>
                                                                    <li>Paramètres système et configurations</li>
                                                                    <li>Signataires et informations société</li>
                                                                </ul>
                                                                <button @click="ouvrirModalReinit('totale')"
                                                                        type="button"
                                                                        class="ti-btn bg-danger text-white w-full">
                                                                    <i class="ri-delete-bin-2-fill me-1"></i>
                                                                    Réinitialiser (totale)
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <!-- ===================== FIN ONGLET RÉINITIALISATION BASE ===================== -->

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>














                </div>
            </div>
        </template>

    </templatesite>


    <modalopenform ref="modalopenform"  ></modalopenform>

    <!-- ===== MODAL CONFIRMATION RÉINITIALISATION ===== -->
    <div v-if="reinitialisation.modalVisible"
         class="fixed inset-0 z-[9999] flex items-center justify-center"
         style="background: rgba(0,0,0,0.55);">
        <div class="bg-white rounded-lg shadow-2xl w-full max-w-lg mx-4">

            <!-- En-tête -->
            <div class="flex items-center justify-between px-5 py-4 border-b"
                 :class="reinitialisation.type === 'totale' ? 'bg-danger/10' : 'bg-warning/10'">
                <div class="flex items-center gap-2">
                    <i :class="reinitialisation.type === 'totale' ? 'ri-delete-bin-2-fill text-danger' : 'ri-refresh-line text-warning'"
                       class="text-xl"></i>
                    <h6 class="mb-0 font-bold"
                        :class="reinitialisation.type === 'totale' ? 'text-danger' : 'text-warning'">
                        Confirmer la réinitialisation {{ reinitialisation.type === 'totale' ? 'totale' : 'partielle' }}
                    </h6>
                </div>
                <button @click="fermerModalReinit" class="text-gray-400 hover:text-gray-600">
                    <i class="ri-close-line text-xl"></i>
                </button>
            </div>

            <!-- Corps -->
            <div class="px-5 py-5">

                <div class="alert alert-danger mb-4 text-[0.8rem]">
                    <i class="ri-error-warning-fill me-1"></i>
                    <strong>Cette opération est irréversible.</strong>
                    Toutes les données concernées seront définitivement supprimées.
                </div>

                <!-- Texte de sécurité à recopier -->
                <div class="mb-4">
                    <p class="text-[0.8rem] text-[#8c9097] mb-2">
                        Pour confirmer, copiez et collez le texte de sécurité ci-dessous dans le champ :
                    </p>
                    <div class="flex items-center gap-2 p-3 rounded-md border-2"
                         :class="reinitialisation.type === 'totale' ? 'border-danger/50 bg-danger/5' : 'border-warning/50 bg-warning/5'">
                        <code class="flex-1 text-[0.8rem] font-bold break-all select-all"
                              :class="reinitialisation.type === 'totale' ? 'text-danger' : 'text-warning'">
                            {{ reinitialisation.securityText }}
                        </code>
                        <button @click="copierTexteSecurite"
                                title="Copier"
                                class="text-gray-400 hover:text-primary flex-shrink-0">
                            <i class="ri-file-copy-line text-lg"></i>
                        </button>
                    </div>
                </div>

                <!-- Champ de saisie -->
                <div class="mb-2">
                    <label class="text-[0.8rem] font-semibold mb-1 block">Saisissez le texte de sécurité :</label>
                    <input type="text"
                           v-model="reinitialisation.inputText"
                           class="form-control w-full"
                           :class="reinitialisation.inputText && !reinitConfirmValid ? 'border-danger' : ''"
                           placeholder="Collez ou saisissez le texte ici..."
                           autocomplete="off">
                    <p v-if="reinitialisation.inputText && !reinitConfirmValid"
                       class="text-danger text-[0.75rem] mt-1">
                        Le texte ne correspond pas.
                    </p>
                </div>

            </div>

            <!-- Pied -->
            <div class="flex justify-end gap-2 px-5 py-4 border-t">
                <button @click="fermerModalReinit"
                        type="button"
                        class="ti-btn ti-btn-secondary">
                    Annuler
                </button>
                <button @click="confirmerReinitialisation"
                        type="button"
                        :disabled="!reinitConfirmValid || reinitialisation.loading"
                        :class="reinitialisation.type === 'totale' ? 'bg-danger' : 'bg-warning'"
                        class="ti-btn text-white disabled:opacity-50 disabled:cursor-not-allowed">
                    <span v-if="reinitialisation.loading">
                        <i class="ri-loader-4-line animate-spin me-1"></i> En cours...
                    </span>
                    <span v-else>
                        <i class="ri-check-line me-1"></i> Oui, réinitialiser
                    </span>
                </button>
            </div>

        </div>
    </div>
    <!-- ===== FIN MODAL CONFIRMATION RÉINITIALISATION ===== -->

</template>

<script>

    import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/setting/menu";


    import * as JwtService from "@/common/jwt.service";
    import {randomString} from "@/allfunction";
    import modalopenform from "@/components/views/pages/stock/mvtstock/modal_openform";
    import serveurdevices from "@/components/views/pages/setting/serveurdevices";
    import auditpaniers from "@/components/views/pages/setting/auditpaniers";
    import shortlinks from "@/components/views/pages/setting/shortlinks";
    import utilisateursconnectes from "@/components/views/pages/setting/utilisateursconnectes";
    import reglagefichetechnique from "@/components/views/pages/setting/reglagefichetechnique";
    import {resetDatabase} from "@/service/indexedDBService";
    const axios =require('axios');


    export default {
        /* eslint-disable */
        name: "ewallet",
        components: {
            templatesite,
            appheader,
            appsidebar,
            appmenu,
            modalopenform,
            serveurdevices,
            auditpaniers,
            shortlinks,
            utilisateursconnectes,
            reglagefichetechnique,

        },
        watch: {
            searchword(newvalue) {
                this.page = 1;
            },
            jsonmnomsignataire(val) {
                if (val && val !== '') {
                    this.mnomsignataire       = val.name;
                    this.msignaturesignataire = this.$store.state.baseurlapi + 'file/' + val.signature;
                } else {
                    this.mnomsignataire       = '';
                    this.msignaturesignataire = '';
                }
            },
        },

        computed:{

            urletatpicture() {
                const doctypeMap = {
                    demandedachat:       { key: 'demandedachat',       prefix: 'd0.PNG'   },
                    achatbcd:            { key: 'achatbcd',            prefix: 'd0.PNG'   },
                    achatbondereception: { key: 'achatbondereception', prefix: 'd0.PNG'   },
                    achatfacture:        { key: 'achatfacture',        prefix: 'd0.PNG'   },
                    achatretoursurachat: { key: 'achatretour',         prefix: 'd0.PNG'   },
                    vente_devis:         { key: 'ventedevis',          prefix: 'd0.PNG'   },
                    ventebcd:            { key: 'ventebcd',            prefix: 'd0.PNG'   },
                    ventebpl:            { key: 'ventebpl',            prefix: 'bpl0.PNG' },
                    ventebl:             { key: 'ventebl',             prefix: 'bl0.PNG'  },
                    ventef:              { key: 'ventefacture',        prefix: 'f0.png'   },
                    venteretourvente:    { key: 'venteretour',         prefix: 'rv0.PNG'  },
                };
                const config = doctypeMap[this.doctype];
                if (!config || !this.datasignataire[config.key]) return '';
                const dossiervalue = parseInt(this.datasignataire[config.key].document);
                return `/gsketat/${dossiervalue}/${config.prefix}`;
            },
            urlfilesignataire() {
                if (!this.msignaturesignataire) return '';
                return this.msignaturesignataire;
            },








            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatablestockminimum(){

                let mvalue=this.datatablestockminimum;

                return this.paginate(mvalue) ;

            },

            filterdatableuploadsignature(){

                let mvalue=this.datatableuploadsignature;

                return mvalue ;

            },
            filterdatablelistenotification(){

                let mvalue=this.datatablenotification;

                return mvalue ;

            },

            reinitConfirmValid() {
                return this.reinitialisation.inputText.trim() === this.reinitialisation.securityText;
            },
        },

        data() {
            return {
                searchword:"",
                datatablefindecontratpermanent:[],
                datatabledocday:[],
                alldatalibelle:[],
                datatablestockminimum:[],
                alldatanotification:{
                    users:[],
                    tpnotif:[],
                },
                datatablenotification:[],
                autorisationsystem:{
                    pid:"",
                    tp:"",
                    authorizesignatureelectronique:false,
                    authorizechangementprix:false,
                    authorizenormalisation:false,
                    authorizeprix0:false,
                    authorizefacturactionpartiel:false,
                    authorizevalidationdoc:false,
                    authorizepointdevente:false,
                    authorizelaproceduredevente:1,
                    authorizelaproceduredevalidationdocstock:1,
                    authorizelavalidationdesdocuments:0,

                },
                doctype:"caisse",
                selectedItemslibelle:null,


                mtitresignataire:'',
                mnomsignataire:'',
                jsonmnomsignataire:'',
                msignaturesignataire:'',
                nbrededocumentactive:6,
                datasignataire:{},
                datasignatairep:{},

                notification:{
                    username:null,
                    tpnotif:null,
                    pid:"",
                },




                nameuploadsignature:'',
                titreuploadsignature:'',
                alldata:[],
                datatableuploadsignature:[],


                Itemssignature:{
                    pid:"",
                    username:null,
                    tpnotif:null,
                },

                etatinformationentreprise:{
                    logo:null,
                    ifu:"",
                    rccm:"",
                    raisonsociale:"",
                    adresse:"",
                    telephonne:"",
                },


                logofile: null,
                logouploadPercentage: 0,
                logopreview: null,
                logoimage: null,


                file: null,
                uploadPercentage: 0,
                preview: null,
                image: null,
                preview_list: [],
                image_list: [],




                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],

                tokennormalisation: {
                    token: '',
                    loading: false,
                    loaded: false,
                    exists: false,
                    dejaenregistre: false,
                    statut: null,          // 'valide' | 'expire' | 'invalide'
                    joursRestants: null,
                    modifiable: false,
                    isupdate: false,
                    maskedToken: '',
                    details: null,
                    editmode: false,
                    modalSupportVisible: false,
                },

                reinitialisation: {
                    modalVisible: false,
                    type: null,
                    securityText: '',
                    inputText: '',
                    loading: false,
                },

                texteSecuritePool: [
                    'REINIT#STOCK-ZERO@HSIG!Confirmer-2024',
                    'BASE-DONNÉES-RESET!PARTIEL#ValidéOK',
                    'SUPPRESSION-TOTALE@BDD#Confirmé2024!',
                    'HSIG-RESET@COMPLET-Validé!DB#2024OK',
                    'Réinitialisation#Confirmée!TOTAL-HSIG',
                    'EFFACEMENT-BDD!Partiel#CONFIRM-HSIG24',
                    'Reset-Stock-Zéro@HSIGCOM!Confirmer24',
                    'BASE-DONNEES#REINIT@Totale!VALID-2024',
                    'CONFIRMATION!HSIG@Reset-DB-Complet#24',
                    'HSIGCOM-EFFACEMENT#TOTAL!Validé@2024',
                ],

            };
        },
        methods: {

          formatDateTime(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            return date.toLocaleString('fr-FR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            });
          },

          formatDateOnly(dateString) {
            if (!dateString) return 'Non définie';
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return 'Non définie';
            return date.toLocaleDateString('fr-FR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            });
          },

            // ─── Helpers partagés ─────────────────────────────────────────
            apiHeaders(contentType = 'application/json') {
                return {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                    'Content-Type': contentType,
                    'Authorization': 'Bearer ' + JwtService.getToken(),
                    'csrftoken': this.$store.state.appsociete,
                };
            },

            handleApiError(responseData) {
                const errors = responseData?.mdataerror ?? [];
                const message = errors.length > 0
                    ? errors.join('\n')
                    : (responseData?.message ?? 'Une erreur est survenue.');
                toastr['error'](message, '<b></b>');
            },
            // ──────────────────────────────────────────────────────────────


          // Applique l'état renvoyé par le backend (m) à l'objet local.
          applyTokenState(m) {
            const tn = this.tokennormalisation;
            tn.exists = !!m.exists;
            tn.dejaenregistre = !!m.dejaenregistre;
            tn.statut = m.statut || null;
            tn.joursRestants = (m.joursRestants !== undefined) ? m.joursRestants : null;
            tn.modifiable = !!m.modifiable;
            tn.isupdate = !!m.isupdate;
            tn.maskedToken = m.maskedToken || '';
            tn.details = m.details || null;
            // Zone de saisie visible si aucun token, ou si modification autorisée.
            tn.editmode = tn.exists ? tn.modifiable : true;
          },

          // Onglet « Appareils serveurs » : (re)charge la présence au clic sur l'onglet.
          chargerServeurDevices() {
            if (this.$refs.serveurdevicesref) this.$refs.serveurdevicesref.charger();
          },

          // Onglet « Utilisateurs connectés » : charge la liste des sessions actives au clic.
          chargerUtilisateursConnectes() {
            if (this.$refs.usersconnectesref) this.$refs.usersconnectesref.charger();
          },

          // Onglet « Audit paniers » : charge l'audit (période du jour) au clic.
          chargerAuditPaniers() {
            if (this.$refs.auditpaniersref) this.$refs.auditpaniersref.charger();
          },

          // Onglet « Liens courts » : charge la liste des liens du raccourcisseur au clic.
          chargerShortlinks() {
            if (this.$refs.shortlinksref) this.$refs.shortlinksref.charger();
          },

          // Exigence 1 : chargement du token depuis la base au montage de la page.
          async loadtokennormalisation() {
            const tn = this.tokennormalisation;
            tn.loading = true;

            const url = this.$store.state.baseurlapi + "/utilitaire/mecef/charger/"
                + randomString(130) + "/" + randomString(60);

            try {
              const response = await axios.get(url, { headers: this.apiHeaders(), withCredentials: true });
              const data = response.data;

              if (data && data.success && data.m) {
                this.applyTokenState(data.m);
              } else {
                tn.exists = false;
              }
              tn.loaded = true;

              // Exigence 2 : le token existe mais n'a jamais été vérifié/enregistré
              // → on vérifie et on enrichit automatiquement la donnée.
              if (tn.exists && !tn.dejaenregistre) {
                await this.verifierEtEnregistrerTokenNormalisation(true);
              }
            } catch (error) {
              tn.loaded = true;
              toastr.error("Impossible de charger le token de normalisation.", "Erreur");
            } finally {
              tn.loading = false;
            }
          },

          // Exigence 2/3 : vérification DGI + enregistrement via le backend.
          // auto = true  → revérification silencieuse du token déjà en base.
          // auto = false → l'utilisateur soumet un (nouveau) token.
          async verifierEtEnregistrerTokenNormalisation(auto = false) {
            const tn = this.tokennormalisation;
            const newToken = auto ? '' : (tn.token || '').trim();

            if (!auto && !newToken) {
              toastr.warning('Veuillez saisir un token avant de vérifier.', 'Champ requis');
              return;
            }

            tn.loading = true;

            const url = this.$store.state.baseurlapi + "/utilitaire/mecef/verifierenregistrer/"
                + randomString(130) + "/" + randomString(60);

            try {
              const response = await axios.post(url, { token: newToken },
                  { headers: this.apiHeaders(), withCredentials: true });
              const data = response.data;

              if (data && data.success && data.m) {
                this.applyTokenState(data.m);
                tn.token = '';
                if (!auto) toastr.success(data.message || 'Token vérifié et enregistré avec succès.', 'Succès');
              } else {
                if (data && data.m && data.m.statut) tn.statut = data.m.statut;
                if (!auto) toastr.error((data && data.message) ? data.message : 'Token invalide.', 'Échec');
              }
            } catch (error) {
              if (!auto) toastr.error("Erreur lors de la vérification du token.", "Erreur");
            } finally {
              tn.loading = false;
            }
          },

          ouvrirModalSupportToken() {
            this.tokennormalisation.modalSupportVisible = true;
          },

          fermerModalSupportToken() {
            this.tokennormalisation.modalSupportVisible = false;
          },

            reset: function() {
                this.uploadPercentage = 0;
                this.titresignature = "";
                this.image = null;
                this.file = null;
                this.preview = null;
                this.image_list = [];
                this.preview_list = [];
            },

            previewImage: function(event) {
                this.image=null;
                this.file=null;
                var input = event.target;
                if (input.files) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.preview = e.target.result;
                    }
                    this.image=input.files[0];
                    this.file=input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
            },
            handleFileUpload( event ){
                this.file = event.target.files[0];
            },

            logopreviewImage: function(event) {
                this.logoimage=null;
                this.logofile=null;
                var input = event.target;
                if (input.files) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                        this.logopreview = e.target.result;
                        this.etatinformationentreprise.logo = e.target.result;
                    }
                    this.logoimage=input.files[0];
                    this.logofile=input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
            },
            logohandleFileUpload( event ){
                this.logofile = event.target.files[0];
            },
            logoreset: function() {
                this.logouploadPercentage = 0;
                this.logoimage = null;
                this.logofile = null;
                this.logopreview = null;
            },

             ajouterline(arrayadd){

                if (arrayadd.length>=6){

                    toastr['error']("Vous ne pouvez pas ajouter de signataire supplémentaire, car vous avez déjà atteint " +
                        "la limite de six (06) signataires autorisés.","<b></b>")
                    this.mtitresignataire="";
                    this.mnomsignataire="";
                    this.msignaturesignataire="";
                    this.jsonmnomsignataire="";
                    return
                }
                arrayadd.push({
                    mtitresignataire:this.mtitresignataire,
                    mnomsignataire:this.mnomsignataire,
                    msignaturesignataire:this.msignaturesignataire,
                    jsonmnomsignataire:this.jsonmnomsignataire,
                })
                this.mtitresignataire="";
                this.mnomsignataire="";
                this.msignaturesignataire="";
                this.jsonmnomsignataire="";
            },

            retirerline(arrayadd,index){
                if (arrayadd.length<=0) return;
                arrayadd.splice(index, 1);

            },

            btnopen(value){


                let titlemodal="Document "+value.numdoc

                let Item=value

                this.$refs.modalopenform.showupdate(titlemodal,"update",this.typedoc,Item,this.otherdata);

            },


            init(){
                this.inittableaustock();
                this.inittableauelistedocday();

            },



            async loadinformationentreprise() {

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/onoeofienfneioefezp849418119815191981dsdsc1dscds9/'+randomString()+'/infosociete/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: this.apiHeaders() ,withCredentials: true
                })

                await response
                    .then(response => {
                        if (response.data.success){

                            t.etatinformationentreprise=response.data.m.etatinformationentreprise
                            t.autorisationsystem=response.data.m.etatautorisation

                        }
                        else{

                        }
                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))



            },
            async loaduploadsignature() {
                   const t = this;
                let url=process.env.VUE_APP_API_URL+'/onoeofienfneioefezp84941811sc1dscds9/'+randomString()+'/785488allsign88454ffdre/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: this.apiHeaders() ,withCredentials: true
                })

                await response
                    .then(response => {
                        if (response.data.success){

                            t.datatableuploadsignature=response.data.m

                        }
                        else{

                        }
                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))



            },
            submitFileinformationentreprise(){

                this.logouploadPercentage = 0;

                const errors = [];
                if (!this.etatinformationentreprise.raisonsociale?.trim())
                    errors.push('La raison sociale est obligatoire.');
                if (!this.etatinformationentreprise.adresse?.trim())
                    errors.push("L'adresse est obligatoire.");
                if (!this.etatinformationentreprise.telephonne?.trim())
                    errors.push('Le numéro de téléphone est obligatoire.');
                if (errors.length > 0) {
                    toastr['error'](errors.join('\n'), '<b>Champs manquants</b>');
                    return;
                }

                this.$store.dispatch('lancerchargement', true);

                let formData = new FormData();
                formData.append('file', this.logofile);
                formData.append('ifu', this.etatinformationentreprise.ifu);
                formData.append('rccm', this.etatinformationentreprise.rccm);
                formData.append('raisonsociale', this.etatinformationentreprise.raisonsociale);
                formData.append('adresse', this.etatinformationentreprise.adresse);
                formData.append('telephonne', this.etatinformationentreprise.telephonne);
                formData.append('rref', randomString(180));
                formData.append('pid', randomString(280));

                /*
                    Make the request to the POST /single-file URL
                */

                let url=this.$store.state.baseurlapi+"/onoeofienfneioefezp84941811sc1dscds9/"+randomString(130)+"/updinfosociete/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,formData,
                    {
                    withCredentials: true,
                        headers: this.apiHeaders('multipart/form-data'),
                        onUploadProgress: function( progressEvent ) {
                            if (this.logofile!==null){
                            this.logouploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))-20
                            this.$refs.logoloaded_n_total.innerHTML = "Télécharger " + progressEvent.loaded + " bytes of " + progressEvent.total;
                            var percent =( (progressEvent.loaded / progressEvent.total) * 100)-20;
                            //_("status").innerHTML = Math.round(percent) + "% Téléchargement...  <i class=\"fa fa-refresh fa-spin fa-2x fa-fw\"></i>";
                            this.$refs.logostatus.innerHTML = Math.round(percent) + "% Téléchargement...  <i class=\"ti-spinner\"></i>";

                            }

                        }.bind(this)



                    }
                )
                    .then(function(response){

                    t.$store.dispatch('lancerchargement',false)

                    if(response.data.success){

                        if (t.logofile!==null){

                        t.$refs.logostatus.innerHTML = Math.round(100) + "% Télécharger..."
                        t.logouploadPercentage=parseInt( Math.round( 100 ))

                        }

                        this.logoimage=null;
                        this.logofile=null;


                        toastr['success']( response.data.message,"<b></b>");
                    }
                    else{

                                                t.handleApiError(response.data);


                    }

                })
                    .catch(function(){
                        t.$store.dispatch('lancerchargement',false)
                    });
            },
            Saveautorisationupdate(){

                if (!this.autorisationsystem.authorizelaproceduredevente) {
                    toastr['error']('Veuillez sélectionner une procédure de vente.', '<b>Champ manquant</b>');
                    return;
                }

                // Réglage fiche technique : même bouton, sa propre route (envoyé seulement s'il a changé)
                if (this.$refs.reglagefichetechnique) { this.$refs.reglagefichetechnique.saveSiModifie(); }

                this.$store.dispatch('lancerchargement', true);

                this.autorisationsystem.pid = randomString(180);
                this.autorisationsystem.tp  = randomString(80);



                let url=this.$store.state.baseurlapi+"/onoeofienfneioefezp84941811sc1dscds9/"+randomString(130)+"/updauto787dfdf/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,this.autorisationsystem,
                    {
                        headers: this.apiHeaders() ,withCredentials: true
                    }
                )
                    .then(function(response){

                    t.$store.dispatch('lancerchargement',false)

                    if(response.data.success){


                        toastr['success']( response.data.message,"<b></b>");
                    }
                    else{

                                                t.handleApiError(response.data);


                    }

                })
                    .catch(function(){
                        t.$store.dispatch('lancerchargement',false)
                    });
            },
            Savesignataire(){


                let $dataerror=[],$messageerrorr="";

                this.$store.dispatch('lancerchargement',true)

                this.datasignataire.pid=randomString(180);
                this.datasignataire.tp=randomString(80);



                let url=this.$store.state.baseurlapi+"/onoeofienfneioefezp84941811sc1dscds9/"+randomString(130)+"/updautoedition787dfdf/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,this.datasignataire,
                    {
                        headers: this.apiHeaders() ,withCredentials: true
                    }
                )
                    .then(function(response){

                    t.$store.dispatch('lancerchargement',false)

                    if(response.data.success){


                        toastr['success']( response.data.message,"<b></b>");
                    }
                    else{

                                                t.handleApiError(response.data);


                    }

                })
                    .catch(function(){
                        t.$store.dispatch('lancerchargement',false)
                    });
            },
            SaveUploadsignature(){

                this.uploadPercentage = 0;

                let $dataerror=[],$messageerrorr="";

                this.$store.dispatch('lancerchargement',true)
                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('tsignature', this.titreuploadsignature);
                formData.append('rref', randomString(180));
                formData.append('pid', randomString(180));


                if (this.file===null ){
                    $dataerror.push("Veuillez choisir la signature.....")
                }

                if (this.titreuploadsignature==="" || this.titreuploadsignature===null){
                    $dataerror.push("Veuillez saisir le titre de la signature.....")
                }

                if ($dataerror.length>0){

                    this.$store.dispatch('lancerchargement',false)

                    $dataerror.forEach(function ($line) {

                        if ($messageerrorr===""){

                            $messageerrorr=$line;
                        }else{

                            $messageerrorr+="\n"+$line;

                        }

                    })

                    toastr['error']( $messageerrorr,"<b></b>");

                    return
                }

                /*
                    Make the request to the POST /single-file URL
                */


                let url=this.$store.state.baseurlapi+"/onoeofienfneioefezp84941811sc1dscds9/"+randomString(130)+"/updsignat854552144775556988/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,formData,
                    {
                    withCredentials: true,
                        headers: this.apiHeaders('multipart/form-data'),
                        onUploadProgress: function( progressEvent ) {
                            if (this.file!==null){
                                this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ))-20
                                this.$refs.loaded_n_total.innerHTML = "Télécharger " + progressEvent.loaded + " bytes of " + progressEvent.total;
                                var percent =( (progressEvent.loaded / progressEvent.total) * 100)-20;
                                //_("status").innerHTML = Math.round(percent) + "% Téléchargement...  <i class=\"fa fa-refresh fa-spin fa-2x fa-fw\"></i>";
                                this.$refs.status.innerHTML = Math.round(percent) + "% Téléchargement...  <i class=\"ti-spinner\"></i>";
                            }

                        }.bind(this)



                    }
                )
                    .then(function(response){


                    t.$store.dispatch('lancerchargement',false)

                    if(response.data.success){

                        t.loaduploadsignature();
                        t.$refs.status.innerHTML = Math.round(100) + "% Télécharger..."
                        t.uploadPercentage=parseInt( Math.round( 100 ))

                        toastr['success']( response.data.message,"<b></b>");



                    }
                    else{

                                                t.handleApiError(response.data);


                    }

                })
                    .catch(function(){
                        });
            },


            async  deletelinenotification(value){

                let $dataerror=[],$messageerrorr="";

                this.$store.dispatch('lancerchargement',true)


                let url=this.$store.state.baseurlapi+"/12478855remonotifuser2iofdofiloadexp2/spdel/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,value,
                    {
                        headers: this.apiHeaders() ,withCredentials: true

                    }
                )
                    .then(function(response){

                        t.$store.dispatch('lancerchargement',false)

                        if(response.data.success){

                            t.loadnotificationusers();

                            toastr['success']( response.data.message,"<b></b>");

                        }
                        else{

                                                        t.handleApiError(response.data);


                        }

                    })
                    .catch(function(){
                        t.$store.dispatch('lancerchargement',false)
                    });
            },

            async  deletelinesignatureUpload(value){

                let $dataerror=[],$messageerrorr="";

                this.$store.dispatch('lancerchargement',true)


                let url=this.$store.state.baseurlapi+"/onoeofienfneioefezp84941811sc1dscds9/"+randomString(130)+"/suppsignat854552144775556988/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,value,
                    {
                        headers: this.apiHeaders() ,withCredentials: true

                    }
                )
                    .then(function(response){

                        t.$store.dispatch('lancerchargement',false)

                        if(response.data.success){

                            t.loaduploadsignature();

                            toastr['success']( response.data.message,"<b></b>");

                        }
                        else{

                                                        t.handleApiError(response.data);


                        }

                    })
                    .catch(function(){
                        });
            },

            async loadnotificationusers() {

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/12478855notifuser2iofdofiloadexp2/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: this.apiHeaders() ,withCredentials: true
                })

                await response
                    .then(response => {
                        if (response.data.success){

                            t.alldatanotification =response.data.m.alldata;
                            t.datatablenotification =response.data.m.datas;

                        }
                        else{
                            t.alldatanotification =[];
                            t.datatablenotification =[];
                        }
                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))



            },

            async loadlibelle() {

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/12478855libelinputindex2iofdofiloadexp2/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: this.apiHeaders() ,withCredentials: true
                })

                await response
                    .then(response => {
                        if (response.data.success){

                            t.alldatalibelle =response.data.datas;
                            t.selectedItemslibelle=null;

            
                        }
                        else{
                            t.alldatalibelle =[];
                            t.selectedItemslibelle =null;
                        }
                    })
                    .catch(

                        error => toastr['error']( "Une erreur est subvenue. <br/> veuillez actualiser la page.",
                            "<b></b>")
                    )
                    .finally(() =>  this.$store.dispatch('lancerchargement',false))



            },

            ajouterlinetonotification(){


                if (this.notification.username===null){return;}
                if (this.notification.tpnotif===null){return;}

                let checkline=0;

                for (let i = 0; i < this.datatablenotification.length; i++) {

                    if (this.datatablenotification[i].userkey === this.notification.username.pid) {

                        if (this.datatablenotification[i].notif.pid === this.notification.tpnotif.pid) {
                            checkline=1

                        }


                    }

                }


                if (checkline===1){
                    toastr['error']("Cette configuration existe déjà.","<b></b>");
                    return
                }

                let $dataerror=[],$messageerrorr="";

                this.$store.dispatch('lancerchargement',true)

                this.notification.kpid=randomString(180);
                this.notification.tp=randomString(80);



                let url=this.$store.state.baseurlapi+"/12478855sssnotifuser2iofdofiloadexp2/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,this.notification,
                    {
                        headers: this.apiHeaders() ,withCredentials: true
                    }
                )
                    .then(function(response){

                        t.$store.dispatch('lancerchargement',false)

                        if(response.data.success){

                            t.loadnotificationusers()

                            t.notification.username=null
                            t.notification.tpnotif=null

                            toastr['success']( response.data.message,"<b></b>");
                        }
                        else{

                                                        t.handleApiError(response.data);


                        }

                    })
                    .catch(function(){
                        t.$store.dispatch('lancerchargement',false)
                    });
            },


            Savelinenotification(){

                if (this.selectedItemslibelle===null){return ;}

                let $dataerror=[],$messageerrorr="";

                this.$store.dispatch('lancerchargement',true)

                this.selectedItemslibelle.kpid=randomString(180);
                this.selectedItemslibelle.tp=randomString(80);

                let url=this.$store.state.baseurlapi+"/12478855libelinputindex2iofdofiloadexp2update/"+this.$store.state.appsociete+'/'+randomString(200);
                let t=this;

                axios.post( url,this.selectedItemslibelle,
                    {
                        headers: this.apiHeaders() ,withCredentials: true
                    }
                )
                    .then(function(response){

                        t.$store.dispatch('lancerchargement',false)

                        if(response.data.success){


                            toastr['success']( response.data.message,"<b></b>");
                        }
                        else{

                                                        t.handleApiError(response.data);


                        }

                    })
                    .catch(function(){
                        t.$store.dispatch('lancerchargement',false)
                    });
            },

            ouvrirModalReinit(type) {
                const pool = this.texteSecuritePool;
                const index = Math.floor(Math.random() * pool.length);
                this.reinitialisation.type        = type;
                this.reinitialisation.securityText = pool[index];
                this.reinitialisation.inputText    = '';
                this.reinitialisation.loading      = false;
                this.reinitialisation.modalVisible = true;
            },

            fermerModalReinit() {
                this.reinitialisation.modalVisible = false;
                this.reinitialisation.inputText    = '';
            },

            copierTexteSecurite() {
                navigator.clipboard.writeText(this.reinitialisation.securityText)
                    .then(() => toastr['success']('Texte de sécurité copié.', '<b></b>'))
                    .catch(() => toastr['error']('Impossible de copier automatiquement.', '<b></b>'));
            },

            async confirmerReinitialisation() {
                if (!this.reinitConfirmValid) return;

                this.reinitialisation.loading = true;
                this.$store.dispatch('lancerchargement', true);



              let url=this.$store.state.baseurlapi+"/onoeofienfneioefezp849418119815191981dsdsc1dscds9/"+randomString(130)+"/resetdb849849849849849/"+this.$store.state.appsociete+'/'+this.reinitialisation.type+'/'+randomString(200);
              const t = this;
               /* const url = this.$store.state.baseurlapi
                    + '/reinitialisation-base/'
                    + this.$store.state.appsociete
                    + '/' + this.reinitialisation.type;*/

                try {
                    const response = await axios.post(url, {
                        type:         this.reinitialisation.type,
                        securityText: this.reinitialisation.securityText,
                        pid:          randomString(180),
                        tp:           randomString(80),
                    }, {
                        headers: this.apiHeaders(),
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        toastr['success'](response.data.message, '<b></b>');
                      resetDatabase()
                      window.location.reload();
                        t.fermerModalReinit();

                    } else {
                        t.handleApiError(response.data);
                    }
                } catch (e) {
                    toastr['error']('Une erreur est survenue lors de la réinitialisation.', '<b></b>');
                } finally {
                    t.reinitialisation.loading = false;
                    t.$store.dispatch('lancerchargement', false);
                }
            },




        },
        mounted() {

            this.datasignataire= JSON.parse(JSON.stringify(this.$store.state.paramsapp.signataire))

            this.loadinformationentreprise()
            this.loaduploadsignature()
            this.loadnotificationusers()
            this.loadlibelle()
            ///this.loadtokennormalisation()



           //this.inittableaustock();
           //this.inittableauelistedocday();
        }






    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/icon?family=Material+Icons');


    .divmenuheader{
        margin-top: 60px;
    }
    .divmenuheader header{
        padding: 15px;
    }



    .img-fluid {
        max-width: 150px!important;
        height: auto;
    }


    .input {
        display: block;
        margin-bottom: 1.5em;
        min-width: 10em;
    }
    .input:hover .input__support {
        border-color: #9fa8b2;
    }
    .input:hover .input__support:before {
        color: #7d8a96;
    }
    .input__text {
        display: block;
        padding-bottom: 0.5em;
        margin-left: 0.18em;
    }
    .input__text sup {
        color: #fe4f3e;
        cursor: help;
    }
    .input .input__support:before {
        font-family: "Material Icons";
        font-weight: normal;
        font-style: normal;
        font-size: 20px;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        word-wrap: normal;
        direction: ltr;
        -webkit-font-feature-settings: "liga";
        -webkit-font-smoothing: antialiased;
    }
    .input .input__support, .input .input__field {
        border-radius: 0;
        display: block;
        width: 100%;
        padding: 0.5rem 0.75rem;
        font-size: 1rem;
        line-height: 1.25;
        color: #464a4c;
        background-color: #fff;
        background-image: none;
        background-clip: padding-box;
        border: 1px solid #c1c7cd;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .input__field:focus + .input__support {
        border-color: #037DE4;
    }
    .input__field:valid + .input__support {
        border-color: #4DD171;
    }
    .input__field:valid + .input__support:before {
        content: "done";
        color: #4DD171;
    }
    .input__field:valid + .input__support .input__helper:before {
        content: "Fichier sélectionné";
        color: #7d8a96;
    }
    .input__field:invalid + .input__support:before {
        content: "file_upload";
    }
    .input__field:invalid + .input__support .input__helper:before {
        content: "Veuillez sélection le fichier de la signature";
    }
    .input__support {
        display: flex !important;
        align-items: center;
    }
    .input__support:before {
        content: "file_upload";
        display: inline-block;
        color: #9fa8b2;
        width: 1.2rem;
        height: 1.2rem;
        margin: -0.5rem 0.5rem -0.5rem -0.2rem;
        transition: color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .input__helper:before {
        font-weight: 200;
        color: #9fa8b2;
        content: "Select file";
    }
    .input--file {
        cursor: pointer;
    }
    .input--file input[type=file] {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
        padding: 0;
    }

    .ti-spinner {
        display: inline-block;
        height: 0.5rem;
        width: 0.5rem;
    }




</style>